import React from "react";
import { fetchBreedTypesByAnimal } from "../../actions/addBreedType";
import { getQuizFeaturesViaBreed, getAvailableQuizBreeds, editBreedQuizFeatures, deleteBreedQuizFeatures, createBreedQuizFeaturesFromFile } from "../../actions/quiz";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { Loader } from "../loader";
import { NotificationManager } from "react-notifications";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import "react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css";
import filterFactory, {
  textFilter,
  selectFilter
} from "react-bootstrap-table2-filter";
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import AddQuizMapping from "./addQuizMapping";
import Select from "react-select";
import _ from 'lodash';
import readXlsxFile from 'read-excel-file';

const $ = window.$;
const { SearchBar } = Search;
var _self;


class CenteredTabs extends React.Component {
  constructor(props) {
    super(props);
    _self = this;
  }
  state = {
    loading: true,
    breedQuizFeaturesNew: [],
    breedQuizData: [],
    breedId: null,
    selectedBreedAttributeList: [],
    allBreedsFreatures : {},
    uploadingFileLoader :  false,
    selectedFile : null,
    defaultBreedArributesArray : ['breedName', 'friendly', 'protective', 'independent', 'energetic','very_energetic', 'low_energy', 'moderate_energy', 'extra_small', 'small',
      'medium', 'large', 'x_large', 'hypoallergenic','minimal_shedding','moderate_shedding', 'high_shedding', 'kid_friendly', 'easy_to_train' ]

  };

  breedQuizColumnData = [
    {
      dataField: "actions",
      text: "Action",
      formatter: this.buttonFormatter.bind(this),
      style: { "overflowX": "visible" },
      headerStyle: (column, colIndex) => {
        return { width: '60px' };
      }
    }, 
    {
      dataField: 'breedName', text: 'Breed', sort: true
    },
    {
      dataField: 'friendly', text: 'Friendly', sort: true
    },
    {
      dataField: 'protective', text: 'Protec-tive', sort: true,
      headerStyle: (column, colIndex) => {
        return { width: '80px' };
      }
    },
    {
      dataField: 'independent', text: 'Indepen-dent', sort: true,
      headerStyle: (column, colIndex) => {
        return { width: '95px' };
      }
    },
    {
      dataField: 'energetic', text: 'Energetic', sort: true,
      headerStyle: (column, colIndex) => {
        return { width: '70px' };
      }
    },
    {
      dataField: 'very_energetic', text: 'Very Energy', sort: true
    },
    {
      dataField: 'low_energy', text: 'Low Energy', sort: true
    },
    {
      dataField: 'moderate_energy', text: 'Mode-rate Energy', sort: true
    },
    {
      dataField: 'extra_small', text: 'Extra Small', sort: true
    },
    {
      dataField: 'small', text: 'Small', sort: true
    },
    {
      dataField: 'medium', text: 'Medium', sort: true
    },
    {
      dataField: 'large', text: 'Large', sort: true
    },
    {
      dataField: 'x_large', text: 'X-Large', sort: true
    },
    {
      dataField: 'hypoallergenic', text: 'Hypoaller -genic', sort: true,
      headerStyle: (column, colIndex) => {
        return { width: '90px' };
      }
    },
    {
      dataField: 'minimal_shedding', text: 'Mini-mal Shedding', sort: true
    },
    {
      dataField: 'moderate_shedding', text: 'Mode-rate Shedding', sort: true
    },
    {
      dataField: 'high_shedding', text: 'High Shedding', sort: true
    },
    {
      dataField: 'kid_friendly', text: 'Kid Friendly', sort: true
    },
    {
      dataField: 'easy_to_train', text: 'Easy to Train', sort: true
    },



  ];

  buttonFormatter(cell, row, rowIndex) {
    return (
      <div>
        <span className="dropdown show">
          <span className="dropdown">
            <a
              href=""
              className="btn m-btn m-btn--hover-brand m-btn--icon m-btn--icon-only m-btn--pill"
              data-toggle="dropdown"
              aria-expanded="true"
            >
              <i className="la la-ellipsis-h"></i>
            </a>
            <div className="dropdown-menu dropdown-menu-right">
              <a
                class="dropdown-item"
                onClick={(e) => { this.onBreedQuizFeaturesEditClick(e, row) }}
              >
                <i className="la la-edit"></i> Edit
              </a>
              <a
                class="dropdown-item"
                onClick={(e) => { this.openBreedQuizFeatureDeleteModal(e, row) }}
              >
                <i className="la la-trash-o"></i> Delete
              </a>
            </div>
          </span>
        </span>
      </div>
    );
  }

  closeModal = () => {  
    this.setState( { breedQuizFeaturesNew : [] });
    $("#edit_quiz_mapping").modal("hide");
  }

  componentDidMount() {
    this.props.getQuizFeaturesViaBreed();
    this.props.getAvailableQuizBreeds();
    this.props.fetchBreedTypesByAnimal(24);
  }

  componentWillReceiveProps = nextProps => {

    if (nextProps.quizFeaturesViaBreed !== this.props.quizFeaturesViaBreed) {
      this.setState({ breedQuizData: nextProps.quizFeaturesViaBreed, loading: false, breedId : null });     
    }

    if (nextProps.breeds && this.props.breeds !== nextProps.breeds) {
      let options = [{ label: "SELECT BREED", value: null }];
      nextProps.breeds.map(p => {
        options.push({ label: p.breed_type, value: p.id });
      });
      this.setState({ breeds: options });
    }

    if (nextProps.createdBreedQuizFeatures !== this.props.createdBreedQuizFeatures) {
      this.props.getQuizFeaturesViaBreed();
    }

    if (nextProps.editedBreedQuizFeatures !== this.props.editedBreedQuizFeatures) {
      NotificationManager.success('Breed attribute edited successfully');
      $('#edit_quiz_mapping').modal('hide');
      this.setState({ loading: false, });
      this.props.getQuizFeaturesViaBreed();
    }

    if (nextProps.deletedBreedQuizFeatures !== this.props.deletedBreedQuizFeatures) {
      NotificationManager.success('Breed attribute deleted successfully');
      $('#confirm_delete_modal').modal('hide');
      this.props.getQuizFeaturesViaBreed();
    }

    if(nextProps.createdBreedQuizFeaturesFromFile !== this.props.createdBreedQuizFeaturesFromFile){
      this.setState({ uploadingFileLoader : false, allBreedsFreatures : {} });
      this.refs.excelUploader.value = null;
      $('#open_file_upload_modal').modal('hide');
      this.props.getQuizFeaturesViaBreed();
      NotificationManager.success('Breed attributes imported successfully');
    }    

    if(nextProps.createdBreedQuizFeaturesFromFileError !== this.props.createdBreedQuizFeaturesFromFileError){
      this.setState({ uploadingFileLoader : false, allBreedsFreatures : {} });
      $('#open_file_upload_modal').modal('hide');
      NotificationManager.error('An error occurred while uploading the file');
    }    


  }

  onBreedQuizFeaturesEditClick1 = (e, row) => {
    e.preventDefault();
    const allFeatureList = this.state.breedQuizData;
    let selectedBreedFeatures = [];
    const index = _.findIndex(allFeatureList, function (o) { return o.breedId == row.breedId; });
    if (index >= 0) {
      selectedBreedFeatures = allFeatureList[index];   
    }
    if (selectedBreedFeatures && selectedBreedFeatures.featuresArray && selectedBreedFeatures.featuresArray.length > 0) {
      const features = selectedBreedFeatures.featuresArray; 
      this.setState({ breedQuizFeaturesNew: features, breedId: row.breedId });
      $('#edit_quiz_mapping').modal('show');
    } else {
      NotificationManager.warning("Breed feature list not found");
    }


  }

  onBreedQuizFeaturesEditClick = (e, row) => {
    e.preventDefault();
    const allFeatureList = this.state.breedQuizData;
    let selectedBreedFeatures = [];
    const index = _.findIndex(allFeatureList, function (o) { return o.BreedId == row.BreedId; });   
    if (index >= 0) {
      selectedBreedFeatures = allFeatureList[index];   
    }else{
      NotificationManager.error("Breed quiz attributes were not found");
    }
    if(!_.isEmpty(selectedBreedFeatures)){
      selectedBreedFeatures.friendly = selectedBreedFeatures.friendly === "Yes" || selectedBreedFeatures.friendly === true ? true : false;
      selectedBreedFeatures.protective = selectedBreedFeatures.protective === "Yes" || selectedBreedFeatures.protective === true ? true : false;
      selectedBreedFeatures.independent = selectedBreedFeatures.independent === "Yes" || selectedBreedFeatures.independent === true ? true : false;
      selectedBreedFeatures.energetic = selectedBreedFeatures.energetic === "Yes" || selectedBreedFeatures.energetic === true ? true : false;
      selectedBreedFeatures.low_energy = selectedBreedFeatures.low_energy === "Yes" || selectedBreedFeatures.low_energy === true ? true : false;
      selectedBreedFeatures.moderate_energy = selectedBreedFeatures.moderate_energy === "Yes" || selectedBreedFeatures.moderate_energy === true? true : false;
      selectedBreedFeatures.extra_small = selectedBreedFeatures.extra_small === "Yes" || selectedBreedFeatures.extra_small === true ? true : false;
      selectedBreedFeatures.small = selectedBreedFeatures.small === "Yes" || selectedBreedFeatures.small === true ? true : false;
      selectedBreedFeatures.medium = selectedBreedFeatures.medium === "Yes" || selectedBreedFeatures.medium === true ? true : false;
      selectedBreedFeatures.large = selectedBreedFeatures.large === "Yes" || selectedBreedFeatures.large === true ? true : false;
      selectedBreedFeatures.x_large = selectedBreedFeatures.x_large === "Yes" || selectedBreedFeatures.x_large === true ? true : false;
      selectedBreedFeatures.hypoallergenic = selectedBreedFeatures.hypoallergenic === "Yes" || selectedBreedFeatures.hypoallergenic === true ? true : false;
      selectedBreedFeatures.moderate_shedding = selectedBreedFeatures.moderate_shedding === "Yes" || selectedBreedFeatures.moderate_shedding === true ? true : false;
      selectedBreedFeatures.high_shedding = selectedBreedFeatures.high_shedding === "Yes" || selectedBreedFeatures.high_shedding === true ? true : false;
      selectedBreedFeatures.kid_friendly = selectedBreedFeatures.kid_friendly === "Yes" || selectedBreedFeatures.kid_friendly === true ? true : false;
      selectedBreedFeatures.easy_to_train = selectedBreedFeatures.easy_to_train === "Yes" || selectedBreedFeatures.easy_to_train === true ? true : false;
      selectedBreedFeatures.very_energetic = selectedBreedFeatures.very_energetic === "Yes" || selectedBreedFeatures.very_energetic === true ? true : false;
      selectedBreedFeatures.minimal_shedding = selectedBreedFeatures.minimal_shedding === "Yes" || selectedBreedFeatures.minimal_shedding === true ? true : false;
      this.setState({ breedQuizFeaturesNew: selectedBreedFeatures, breedId: row.BreedId },()=>{
        $('#edit_quiz_mapping').modal('show');
      });
    }else{
      NotificationManager.error("Breed quiz attributes were not found");
    }   

  }

  openBreedQuizFeatureDeleteModal = (e, row) => {
    this.setState({ breedId: row.id });
    $('#confirm_delete_modal').modal('show');
  }

  deleteBreedQuizs(e) {
    e.preventDefault();
    let id = this.state.breedId;
    this.props.deleteBreedQuizFeatures(id);
  }

  submitBreedQuizFeatures(e) {
    e.preventDefault(); 
    let data = this.state.breedQuizFeaturesNew;
    if (data) {
      this.setState({ loading: true });
      this.props.editBreedQuizFeatures(data.id, data);
    }
  }

  checkboxHandler = (e) => {  
    const breedId = this.state.breedId;
    if (breedId) {
      let breedQuizFeatures = this.state.breedQuizFeaturesNew;
      breedQuizFeatures[e.target.name] = e.target.checked;
      this.setState({ breedQuizFeaturesNew: breedQuizFeatures });
    } else {
      NotificationManager.warning("Please select the breed first");
    }

  }


  _onChange =  () => {
    this.setState({ allBreedFeatures : [] },
      async () => {
   
      let selectedFile =  this.refs.excelUploader && this.refs.excelUploader.files[0] ? this.refs.excelUploader.files[0] : null;  

      let allBreedFeatures = [];
      let allowedExtensions = /(\.xlsx)$/i;
      let fileName = selectedFile ? selectedFile.name : null;
      let featureNames = this.state.defaultBreedArributesArray;
      if(allowedExtensions.exec(fileName)){
        let featuresStack = await readXlsxFile(selectedFile);    
        for(let i = 1; i < featuresStack.length; i++) {
          let featureObject = {};     
          let breedFeaturesArray = featuresStack[i];
          for(let j = 0; j < breedFeaturesArray.length; j++) {             
              if(j==0){
                featureObject['breed'] = breedFeaturesArray &&  breedFeaturesArray[j] ? breedFeaturesArray[j].toUpperCase() : "";
              }else{                
                let currentFeatureName = featureNames[j]
                featureObject[currentFeatureName] = breedFeaturesArray[j];
              }              
          }  
          allBreedFeatures.push(featureObject); 
        } 
        this.setState({ allBreedsFreatures : allBreedFeatures, selectedFile : selectedFile });
      }else{
        this.refs.excelUploader.value = null;
        NotificationManager.error("Please upload the file having extensions .xlsx");
      }   
    });

  
  };

  uploadExcelFile = () => {
    let readAllFeatureList = this.state.allBreedsFreatures;
    if(!_.isEmpty(readAllFeatureList)){  
      this.props.createBreedQuizFeaturesFromFile({ breedFeatures : readAllFeatureList });
      this.setState({ uploadingFileLoader : true });
    }else{
      NotificationManager.error("Please select file before proceeding with the upload.");
    }

  }

  render() {
    const { classes, theme, pdfStatus } = this.props;
    const { breedQuizData, breeds, breedId, breedQuizFeaturesNew } = this.state;

    return (
      <div className="m-form m-form--label-align-right m--margin-top-20 m--margin-bottom-30">
        <div className="m-grid__item m-grid__item--fluid m-grid m-grid--hor-desktop m-grid--desktop">
          <div className="row align-items-center">
            <div className="col-xl-8 order-2 order-xl-1">
            </div>
            <div className="col-xl-4 order-1 order-xl-2 m--align-right">
              <button className="btn btn-accent m-btn m-btn--custom m-btn--pill m-btn--icon m-btn--air mb-4" data-toggle="modal" data-target="#add_quiz_mapping">
                <span>
                  <i className="la la-plus"></i>
                  <span>New Quiz Mapping</span>
                </span>
              </button>   
              <button className="btn btn-accent m-btn m-btn--custom m-btn--pill m-btn--icon m-btn--air mb-4 ml-2" data-toggle="modal" data-target="#open_file_upload_modal">
                <span>
                  <i className="la la-file"></i>
                  <span>Import From File</span>
                </span>
              </button>            
              <div className="m-separator m-separator--dashed d-xl-none"></div>
            </div>
          </div>
          <div className="col-xl-12 order-2 order-xl-1">
            {this.state.loading ?
              <div className="col-md-12" style={{ textAlign: 'center' }}>
                <Loader width="100px" height="100px;" />
              </div> :
              <ToolkitProvider
                keyField="id"
                data={breedQuizData}
                columns={this.breedQuizColumnData}
                search
                hover={true}
                filter={filterFactory()}
              >
                {props => (
                  <div>
                    <div className="px-0 mb-4 search-bar">
                      <div className="col-lg-3 px-0 inner-addon right-addon">
                        <i className="fas fa-search"></i>
                        <SearchBar {...props.searchProps} />
                      </div>
                    </div>
                    <BootstrapTable
                      classes="petTable"
                      {...props.baseProps}
                      pagination={paginationFactory()}
                    />
                  </div>
                )}
              </ToolkitProvider>
            }
          </div>
        </div>
        <AddQuizMapping />
        <div
          className="modal fade show"
          id="edit_quiz_mapping"
          tabIndex="-1"
          role="dialog"
          data-backdrop="static"
        >
          <div className="modal-dialog" role="document">
            <div className="modal-content">
              <form className="m-form">
                <div className="modal-header">
                  <h5 className="modal-title" id="exampleModalLabel">
                    Edit Quiz Mapping
                  </h5>
                  <button
                    type="button"
                    className="close"
                    onClick={this.closeModal}
                    aria-label="Close"
                  >
                    <span aria-hidden="true">×</span>
                  </button>
                </div>
                <div className="modal-body">
                  <div className="row">
                    <div className="col-xl-12">
                      <div className="m-form__section m-form__section--first">
                        <div className="form-group m-form__group row">
                          <label className="col-xl-3 col-lg-3 col-form-label">
                            Breed
                          </label>
                          <div className="col-xl-9 col-lg-9">
                            <Select
                              options={breeds}
                              value={breedId}
                              name="breedId"
                              disabled
                            />
                          </div>
                        </div>
                        { breedQuizFeaturesNew &&
                        <div className="form-group m-form__group row pb-0">    
                            <div className="col-6">
                              <div className="m-widget4">
                                <div className="m-widget4__item">
                                  <div className="m-widget4__img m-widget4__img--icon">
                                    <input type="checkbox" name="friendly" checked={breedQuizFeaturesNew.friendly} onChange={(e) => this.checkboxHandler(e)} />
                                  </div>
                                  <div className="m-widget4__info">
                                    <span className="m-widget4__text">
                                         Friendly/Sociable
                                    </span>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="col-6">
                              <div className="m-widget4">
                                <div className="m-widget4__item">
                                  <div className="m-widget4__img m-widget4__img--icon">
                                    <input type="checkbox" name="protective" checked={breedQuizFeaturesNew.protective} onChange={(e) => this.checkboxHandler(e)} />
                                  </div>
                                  <div className="m-widget4__info">
                                    <span className="m-widget4__text">
                                        Protective
                                    </span>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="col-6">
                              <div className="m-widget4">
                                <div className="m-widget4__item">
                                  <div className="m-widget4__img m-widget4__img--icon">
                                    <input type="checkbox" name="independent" checked={breedQuizFeaturesNew.independent} onChange={(e) => this.checkboxHandler(e)} />
                                  </div>
                                  <div className="m-widget4__info">
                                    <span className="m-widget4__text">
                                       Independent/Bold
                                    </span>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="col-6">
                              <div className="m-widget4">
                                <div className="m-widget4__item">
                                  <div className="m-widget4__img m-widget4__img--icon">
                                    <input type="checkbox" name="energetic" checked={breedQuizFeaturesNew.energetic} onChange={(e) => this.checkboxHandler(e)} />
                                  </div>
                                  <div className="m-widget4__info">
                                    <span className="m-widget4__text">
                                       Energetic/Active
                                    </span>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="col-6">
                              <div className="m-widget4">
                                <div className="m-widget4__item">
                                  <div className="m-widget4__img m-widget4__img--icon">
                                    <input type="checkbox" name="very_energetic" checked={breedQuizFeaturesNew.very_energetic} onChange={(e) => this.checkboxHandler(e)} />
                                  </div>
                                  <div className="m-widget4__info">
                                    <span className="m-widget4__text">
                                       Very Energetic
                                    </span>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="col-6">
                              <div className="m-widget4">
                                <div className="m-widget4__item">
                                  <div className="m-widget4__img m-widget4__img--icon">
                                    <input type="checkbox" name="low_energy" checked={breedQuizFeaturesNew.low_energy} onChange={(e) => this.checkboxHandler(e)} />
                                  </div>
                                  <div className="m-widget4__info">
                                    <span className="m-widget4__text">
                                       Low Energy
                                    </span>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="col-6">
                              <div className="m-widget4">
                                <div className="m-widget4__item">
                                  <div className="m-widget4__img m-widget4__img--icon">
                                    <input type="checkbox" name="moderate_energy" checked={breedQuizFeaturesNew.moderate_energy} onChange={(e) => this.checkboxHandler(e)} />
                                  </div>
                                  <div className="m-widget4__info">
                                    <span className="m-widget4__text">
                                      Moderate Energy
                                    </span>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="col-6">
                              <div className="m-widget4">
                                <div className="m-widget4__item">
                                  <div className="m-widget4__img m-widget4__img--icon">
                                    <input type="checkbox" name="extra_small" checked={breedQuizFeaturesNew.extra_small} onChange={(e) => this.checkboxHandler(e)} />
                                  </div>
                                  <div className="m-widget4__info">
                                    <span className="m-widget4__text">
                                       Extra Small {"<10lbs"}
                                    </span>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="col-6">
                              <div className="m-widget4">
                                <div className="m-widget4__item">
                                  <div className="m-widget4__img m-widget4__img--icon">
                                    <input type="checkbox" name="small" checked={breedQuizFeaturesNew.small} onChange={(e) => this.checkboxHandler(e)} />
                                  </div>
                                  <div className="m-widget4__info">
                                    <span className="m-widget4__text">
                                        Small{"<20lbs"}
                                    </span>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="col-6">
                              <div className="m-widget4">
                                <div className="m-widget4__item">
                                  <div className="m-widget4__img m-widget4__img--icon">
                                    <input type="checkbox" name="medium" checked={breedQuizFeaturesNew.medium } onChange={(e) => this.checkboxHandler(e)} />
                                  </div>
                                  <div className="m-widget4__info">
                                    <span className="m-widget4__text">
                                       Medium(20-50lbs)
                                    </span>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="col-6">
                              <div className="m-widget4">
                                <div className="m-widget4__item">
                                  <div className="m-widget4__img m-widget4__img--icon">
                                    <input type="checkbox" name="large" checked={ breedQuizFeaturesNew.large } onChange={(e) => this.checkboxHandler(e)} />
                                  </div>
                                  <div className="m-widget4__info">
                                    <span className="m-widget4__text">
                                      Large(50-100lbs)
                                    </span>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="col-6">
                              <div className="m-widget4">
                                <div className="m-widget4__item">
                                  <div className="m-widget4__img m-widget4__img--icon">
                                    <input type="checkbox" name="x_large" checked={ breedQuizFeaturesNew.x_large } onChange={(e) => this.checkboxHandler(e)} />
                                  </div>
                                  <div className="m-widget4__info">
                                    <span className="m-widget4__text">
                                      X-Large
                                    </span>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="col-6">
                              <div className="m-widget4">
                                <div className="m-widget4__item">
                                  <div className="m-widget4__img m-widget4__img--icon">
                                    <input type="checkbox" name="hypoallergenic" checked={ breedQuizFeaturesNew.hypoallergenic } onChange={(e) => this.checkboxHandler(e)} />
                                  </div>
                                  <div className="m-widget4__info">
                                    <span className="m-widget4__text">
                                      Hypoallergenic
                                    </span>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="col-6">
                              <div className="m-widget4">
                                <div className="m-widget4__item">
                                  <div className="m-widget4__img m-widget4__img--icon">
                                    <input type="checkbox" name="minimal_shedding" checked={ breedQuizFeaturesNew.minimal_shedding } onChange={(e) => this.checkboxHandler(e)} />
                                  </div>
                                  <div className="m-widget4__info">
                                    <span className="m-widget4__text">
                                        Minimal Shedding
                                    </span>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="col-6">
                              <div className="m-widget4">
                                <div className="m-widget4__item">
                                  <div className="m-widget4__img m-widget4__img--icon">
                                    <input type="checkbox" name="moderate_shedding" checked={ breedQuizFeaturesNew.moderate_shedding } onChange={(e) => this.checkboxHandler(e)} />
                                  </div>
                                  <div className="m-widget4__info">
                                    <span className="m-widget4__text">
                                      Moderate Sheddings
                                    </span>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="col-6">
                              <div className="m-widget4">
                                <div className="m-widget4__item">
                                  <div className="m-widget4__img m-widget4__img--icon">
                                    <input type="checkbox" name="high_shedding" checked={ breedQuizFeaturesNew.high_shedding } onChange={(e) => this.checkboxHandler(e)} />
                                  </div>
                                  <div className="m-widget4__info">
                                    <span className="m-widget4__text">
                                      High Shedding
                                    </span>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="col-6">
                              <div className="m-widget4">
                                <div className="m-widget4__item">
                                  <div className="m-widget4__img m-widget4__img--icon">
                                    <input type="checkbox" name="kid_friendly" checked={ breedQuizFeaturesNew.kid_friendly } onChange={(e) => this.checkboxHandler(e)} />
                                  </div>
                                  <div className="m-widget4__info">
                                    <span className="m-widget4__text">
                                      Kid Friendly
                                    </span>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="col-6">
                              <div className="m-widget4">
                                <div className="m-widget4__item">
                                  <div className="m-widget4__img m-widget4__img--icon">
                                    <input type="checkbox" name="easy_to_train" checked={ breedQuizFeaturesNew.easy_to_train } onChange={(e) => this.checkboxHandler(e)} />
                                  </div>
                                  <div className="m-widget4__info">
                                    <span className="m-widget4__text">
                                       Easy to Train
                                    </span>
                                  </div>
                                </div>
                              </div>
                            </div>
                        </div>
                       }
                      </div>
                    </div>
                  </div>
                </div>
                <div className="modal-footer">
                  {this.state.loading == false ? (
                    <div>
                      <button
                        type="button"
                        className="btn btn-secondary m-btn--pill mx-2"
                        onClick={this.closeModal}
                      >
                        Close
                      </button>
                      <button
                        onClick={(e) => { this.submitBreedQuizFeatures(e); }}
                        type="submit"
                        className="btn btn-primary m-btn--pill"
                      >
                        Submit
                      </button>
                    </div>
                  ) : (
                    <div className="center-row">
                      <Loader size={50} />
                    </div>
                  )}
                </div>
              </form>
            </div>
          </div>
        </div>

        <div className="modal fade" id="confirm_delete_modal" tabIndex="-1" role="dialog" aria-labelledby="ConfirmationModalLabel" aria-hidden="true">
          <div className="modal-dialog" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title" id="exampleModalLabel">Confirm To Delete</h5>
                <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div className="modal-body">
                <p>Are you sure you want to delete this breed quiz features?</p>
              </div>
              <div className="modal-footer">
                <div>
                  <button type="button" className="btn btn-secondary m-btn--pill mx-2" data-dismiss="modal">Cancel</button>
                  <button type="button" onClick={(e) => this.deleteBreedQuizs(e)} className="btn btn-primary m-btn--pill">Confirm</button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="modal fade" id="confirm_upload_file_modal" tabIndex="-1" role="dialog" aria-labelledby="ConfirmationModalLabel" aria-hidden="true">
          <div className="modal-dialog" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title" id="exampleModalLabel">Confirm To Upload</h5>
                <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div className="modal-body">
                <p>Are you sure you want to upload this files?</p>
              </div>
              <div className="modal-footer">
                <div>
                  <button type="button" className="btn btn-secondary m-btn--pill mx-2" data-dismiss="modal">Cancel</button>
                  <button type="button" onClick={(e) => this.uploadExcelFile(e)} className="btn btn-primary m-btn--pill">Confirm</button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="modal fade" id="open_file_upload_modal" tabIndex="-1" role="dialog" aria-labelledby="ConfirmationModalLabel" aria-hidden="true">
          <div className="modal-dialog" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title" id="exampleModalLabel">Upload File</h5>
                <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div className="modal-body">
                <form>
                  <div className="m-form form-group m-form__group row mb-0">
                    <label className="col-4 pt-1">
                      Upload File:
                    </label>
                    <div className="col-8 input-group m-input-group pl-0">                                 
                      <input
                        ref="excelUploader"
                        type="file"
                        onChange={this._onChange}
                      />  
                        <p><small>Allow file type is<strong> .xlsx</strong></small></p>      
                    </div>                                         
                  </div>                       	                   
	              </form>    
              </div>         
              <div className="modal-footer">
                { !this.state.uploadingFileLoader ?
                <div>
                  <button type="button" className="btn btn-secondary m-btn--pill mx-2" data-dismiss="modal">Cancel</button>
                  <button type="button" onClick={(e) => this.uploadExcelFile(e)} className="btn btn-primary m-btn--pill">Upload</button>
                </div>:
                <div className="center-row">
                  <Loader size={50} />
                </div>
                 }
              </div> 
              
            </div>
          </div>
        </div>

      </div>
    );
  }
}

const mapStateToProps = state => ({
  deletedZipCodeError: state.customersReducer.customersReducer,
  quizFeaturesViaBreed: state.quizReducer.quizFeaturesViaBreed,
  createdBreedQuizFeatures: state.quizReducer.createdBreedQuizFeatures,
  breeds: state.addBreedTypeReducer.breedsByAnimal,
  editedBreedQuizFeatures: state.quizReducer.editedBreedQuizFeatures,
  deletedBreedQuizFeatures: state.quizReducer.deletedBreedQuizFeatures,
  createdBreedQuizFeaturesFromFile : state.quizReducer.createdBreedQuizFeaturesFromFile,
  createdBreedQuizFeaturesFromFileError : state.quizReducer.createdBreedQuizFeaturesFromFileError,
});

const mapDispatchToProps = dispatch => ({

  getQuizFeaturesViaBreed: () => {
    dispatch(getQuizFeaturesViaBreed());
  },
  getAvailableQuizBreeds: () => {
    dispatch(getAvailableQuizBreeds());
  },
  fetchBreedTypesByAnimal: (breed) => {
    dispatch(fetchBreedTypesByAnimal(breed));
  },
  editBreedQuizFeatures: (id, data) => {
    dispatch(editBreedQuizFeatures(id, data));
  },
  deleteBreedQuizFeatures: (id) => {
    dispatch(deleteBreedQuizFeatures(id));
  },
  createBreedQuizFeaturesFromFile: (data) => {
    dispatch(createBreedQuizFeaturesFromFile(data));
  }
});

CenteredTabs = connect(mapStateToProps, mapDispatchToProps)(CenteredTabs);

export default withRouter(CenteredTabs);